// src/components/rental-managers/AutomatedShowings.jsx


import React from 'react';
import { Box, Typography, Grid, List, ListItem, ListItemText } from '@mui/material';
import AutomatedShowingsStyles from './AutomatedShowings.styles';

const AutomatedShowings = () => {
  return (
    <Box sx={AutomatedShowingsStyles.container}>
      <Grid container spacing={6} alignItems="center">
        {/* Left Side - Icons */}
        <Grid item xs={12} md={4} sx={AutomatedShowingsStyles.iconContainer}>
          <img 
            src="/images/icons.png" 
            alt="Showing Platforms" 
            style={AutomatedShowingsStyles.iconImage} 
          />
        </Grid>

        {/* Right Side - Text Content */}
        <Grid item xs={12} md={8} sx={AutomatedShowingsStyles.textContainer}>
          <Typography variant="h5" sx={AutomatedShowingsStyles.title}>
            COSTS FOR AUTOMATED SHOWINGS
          </Typography>
          
          <Typography variant="body1" sx={AutomatedShowingsStyles.description}>
          Going keyless for intuitive automated showings is included{' '}
            <Typography component="span" sx={AutomatedShowingsStyles.highlight}>
            in your monthly subscription fee-using
            </Typography>{' '}
            the smart locks and the devices you’ll already have with the smart package.
          </Typography>

          <Typography variant="body1" sx={AutomatedShowingsStyles.description}>
            <Typography component="span" sx={AutomatedShowingsStyles.highlight}>
              Our showing service replaces about 85% of all tasks
            </Typography>{' '}
            associated with leasing.
          </Typography>

          {/* Benefits List */}
          <List sx={AutomatedShowingsStyles.list}>
            {[
              'One-time passcodes',
              'ID Verify/Camera use to ID verify',
              'Qualifying prescreen questionnaires that do not require credit card information.',
              'You set qualifying or automatic decline criteria. Showings that do not meet your criteria will generate alerts for your manual review.',
              'Legal conscious questionnaire, including ESA/Service animals',
              'Automatic Feedback requests and your application links sent after showings with your contact information',
              'Renter scheduling without overlapping appointments',
              'Question explainers to help renters understand how timing, income, and scheduling may influence their ability to be considered.',
              'Easily share listing links to include in your rental listings for easy automated showings.',
            ].map((benefit, index) => (
              <ListItem key={index} sx={AutomatedShowingsStyles.listItem}>
                <ListItemText 
                  primary={
                    <Typography component="span" sx={benefit.includes(':') ? AutomatedShowingsStyles.boldText : null}>
                      {benefit}
                    </Typography>
                  } 
                />
              </ListItem>
            ))}
          </List>
        </Grid>
      </Grid>
    </Box>
  );
};

export default AutomatedShowings;

